import { Component } from '@angular/core';

@Component({
  selector: 'app-basic401',
  templateUrl: './basic401.component.html',
  styleUrl: './basic401.component.scss',
})
export class Basic401Component {}
